import { z } from 'zod';

import { syncEntityTypeValues, syncPullEntityTypeValues } from './sync.dto.js';

export const SyncClientIdentitySchema = z.object({
  stationId: z.uuid(),
  deviceId: z.uuid(),
  deviceClaimId: z.uuid(),
});

export const SyncEntityTypeSchema = z.enum(syncEntityTypeValues);
export const SyncPullEntityTypeSchema = z.enum(syncPullEntityTypeValues);
